<template>
  <v-container
    class="pa-3"
    fluid
  >
    <v-layout wrap>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.degrees_per_pixel)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.degrees_per_pixel.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.degrees_per_pixel.$touch()"
          hint="Resolution with which to compute the model"
          label="Resolution"
          suffix="deg/pixel"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.degrees_per_pixel"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.wind_speed_relation)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.wind_speed_relation.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.wind_speed_relation.$touch()"
          disabled
          hint="Empirical wind speed and coronal field topology relation"
          label="Wind speed relation"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.wind_speed_relation"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.rotate)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.rotate.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.rotate.$touch()"
          hint="Rotation to account for older data at 0.1 AU than lower down"
          label="Rotation"
          suffix="deg"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.rotate"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.speed.add)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.speed.add.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.speed.add.$touch()"
          label="Speed correction"
          suffix="km/s"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.speed.add"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.speed.max)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.speed.max.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.speed.max.$touch()"
          label="Maximum speed"
          suffix="km/s"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.speed.max"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.speed.min)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.speed.min.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.speed.min.$touch()"
          label="Minimum speed"
          suffix="km/s"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.speed.min"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.magnetic_field)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.magnetic_field.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.magnetic_field.$touch()"
          hint="Magnetic field at maximal solar wind speed"
          label="Fast wind magnetic field"
          suffix="nT"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.magnetic_field"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.solar_wind.pressure)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.solar_wind.pressure.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.solar_wind.pressure.$touch()"
          hint="Constant thermal pressure"
          label="Solar wind pressure"
          step="0.1"
          suffix="nPa"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.solar_wind.pressure"
        ></v-text-field>
      </v-flex>
      <v-flex
        class="px-2"
        md4
        xs12
      >
        <v-text-field
          :error-messages="errorMessages($v.myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.number_density)"
          @blur="$v.myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.number_density.$touch()"
          @input="$v.myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.number_density.$touch()"
          hint="Number density of fast solar wind"
          label="Fast wind density"
          suffix="1/cm3"
          type="number"
          v-model="myRun.config.coronal_model.HeliosphereBoundary.fast_solar_wind.number_density"
        ></v-text-field>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import runMixin from '@/mixins/run';

export default {
  mixins: [runMixin],
};
</script>
